import { APIService } from "src/services/apiService";
import { AuthenticationService } from "src/services/authenticationService";
import { EmailVerificationStatus } from "src/types";

class UserEmailAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/user/email/verification");
  }

  async patchUserEmailVerification(): Promise<EmailVerificationStatus> {
    return await this.jwtRequest("PATCH");
  }

  async postUserEmailVerificationEmail(): Promise<EmailVerificationStatus> {
    const path = `/email`;
    return await this.jwtRequest("POST", path);
  }
}

export { UserEmailAPIService };
